$shm_hitalama_map_page_keyboard_move $mol_object
	Map_page $shm_hitalama_map_page
	auto null
